<template>
  <vca-card class="shadowed">
    <vca-field :label="$t('taking.log.title')">
      <div
        :key="index"
        v-for="(res, index) in value.activities.slice().reverse()"
      >
        <vca-card>
          <vca-row>
            <h3 first>
              {{ res.user.full_name }} ({{ datetime(res.modified.created) }})
            </h3>
            <div>
              {{ getComment(res) }}
            </div>
            <div>
              <button
                class="vca-button-small m-0"
                @click="getMsgTarget(res)"
                v-if="hasDepositId(res)"
              >
                {{ $t("taking.log.open." + res.model_type) }}
              </button>
            </div>
            <h3 last class="activity_status">
              {{ $t("taking.log.state." + res.model_type + "." + res.status) }}
            </h3>
          </vca-row>
        </vca-card>
      </div>
    </vca-field>
  </vca-card>
</template>
<script>
export default {
  name: "TakingEditActivity",
  props: {
    value: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    depositLink(deposit_id) {
      this.$router.push({ path: "/finances/deposit/edit/" + deposit_id });
    },
    hasDepositId(res) {
      return (
        typeof res.comment === "string" && res.comment.split(";").length > 1
      );
    },
    getMsgTarget(res) {
      if (res.model_type === "deposit") {
        let deposit_id = res.comment.split(";")[1];
        return this.depositLink(deposit_id);
      }
      return null;
    },
    getComment(res) {
      let output = this.$t(
        "taking.log.msg." + res.model_type + "." + res.status
      );
      if (res.comment) {
        output += ": " + res.comment.split(";")[0];
      }

      return output;
    },
  },
};
</script>
<style lang="scss">
.activity_status {
  text-align: right;
}
.m-0 {
  margin: 0;
}
</style>
